'use client'

import { DEFAULT_FLAG_ENTRY } from '../core/types'
import type { FlagEntry } from '../core/types'
import { useFlagContext } from './flag-provider'

export function useFlag(key: string): FlagEntry {
  const flags = useFlagContext()
  return flags[key] ?? DEFAULT_FLAG_ENTRY
}
